export interface DiagnosticsReport {
  timestamp: string;
  app: AppInfo;
  user?: UserInfo;
  browser: BrowserInfo;
  screen: ScreenInfo;
  locale: LocaleInfo;
  technology: TechnologyInfo;
  network: NetworkInfo;
}

export interface AppInfo {
  id: string;
  version?: string;
  environment?: string;
}

export interface UserInfo {
  id: string;
  username?: string;
}

export interface BrowserInfo {
  name: string;
  version: string;
  userAgent: string;
  language: string;
  languages: string[];
  cookiesEnabled: boolean;
  localStorageAvailable: boolean;
  sessionStorageAvailable: boolean;
}

export interface ScreenInfo {
  resolution: string;
  viewport: string;
  devicePixelRatio: number;
  touchSupported: boolean;
}

export interface LocaleInfo {
  timezone: string;
  timezoneOffset: number;
  locale: string;
}

export interface TechnologyInfo {
  webgl: boolean;
  webglRenderer?: string;
  webgl2: boolean;
  webWorkers: boolean;
  serviceWorker: boolean;
  indexedDB: boolean;
  webSockets: boolean;
}

export interface NetworkInfo {
  online: boolean;
  endpoints: EndpointTestResult[];
}

export type EndpointStatus =
  'pending' | 'success' | 'slow' | 'error' | 'timeout';

export interface EndpointTestResult {
  name: string;
  url: string;
  origin: string;
  docPath: string;
  endpointKeys: string[];
  status: EndpointStatus;
  latencyMs?: number;
  errorMessage?: string;
  description?: string;
}

export const LATENCY_THRESHOLD_SUCCESS = 2000;
export const LATENCY_THRESHOLD_SLOW = 5000;

export const DIAGNOSTICS_LABELS = {
  pageTitle: 'Systemdiagnose',
  exportButton: 'Als JSON exportieren',
  runAllTests: 'Alle Tests ausführen',

  browserSection: 'Browser & Umgebung',
  technologySection: 'Technologie-Unterstützung',
  networkSection: 'Netzwerk-Test',

  browserName: 'Browser',
  browserVersion: 'Version',
  userAgent: 'User Agent',
  language: 'Sprache',
  languages: 'Sprachen',
  cookiesEnabled: 'Cookies aktiviert',
  localStorageAvailable: 'Local Storage verfügbar',
  sessionStorageAvailable: 'Session Storage verfügbar',

  resolution: 'Bildschirmauflösung',
  viewport: 'Viewport',
  devicePixelRatio: 'Pixel Ratio',
  touchSupported: 'Touch-Unterstützung',

  timezone: 'Zeitzone',
  timezoneOffset: 'Zeitverschiebung',
  locale: 'Locale',

  webgl: 'WebGL',
  webgl2: 'WebGL 2',
  webglRenderer: 'WebGL Renderer',
  webWorkers: 'Web Workers',
  serviceWorker: 'Service Worker',
  indexedDB: 'IndexedDB',
  webSockets: 'WebSockets',

  online: 'Online-Status',
  endpoint: 'Endpunkt',
  origin: 'Origin',
  status: 'Status',
  latency: 'Latenz',

  statusPending: 'Ausstehend',
  statusSuccess: 'Erfolgreich',
  statusSlow: 'Langsam',
  statusError: 'Fehler',
  statusTimeout: 'Zeitüberschreitung',

  yes: 'Ja',
  no: 'Nein',
  unknown: 'Unbekannt',
};
